import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class FITHSlideShowPage extends SlideShowPage {

    constructor(textures: PIXI.Texture[]) {
        super(undefined, undefined);

        if (textures.length === 1) {
            const image: PIXI.Sprite = new PIXI.Sprite(textures[0]);
            image.anchor.set(0.5);
            this.addChild(image);
        } else {
            const xPos: number = 20,
                imageLeft: PIXI.Sprite = new PIXI.Sprite(textures[0]),
                imageRight: PIXI.Sprite = new PIXI.Sprite(textures[1]);

            imageLeft.anchor.set(1, 0.5);
            imageLeft.x = -xPos;

            imageRight.anchor.set(0, 0.5);
            imageRight.x = xPos;

            this.addChild(imageLeft, imageRight);
        }
    }
}